import { cn } from '@/lib/utils'

export interface CheckCaseInformationErrorBoundaryProps {
  message: string
}

export const CheckCaseInformationErrorBoundary = ({ message }: CheckCaseInformationErrorBoundaryProps) => {
  return (
    <div className={cn('rounded-[9px]', 'bg-secondary', 'px-4 py-3', 'text-xs font-normal leading-6')}>{message}</div>
  )
}
